import React, { useState } from "react";
import axios from "axios";
import API_URL from '../config';
import logo from '../gmtest.png'; // [수정] 로고 파일 import

export default function LoginPage({ onLoginSuccess }) {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    try {
      const res = await axios.post(`${API_URL}/api/login`, {
        username: userId,
        password: password,
      });

      const { token, authorizedMenus, user } = res.data;

      localStorage.setItem("token", token);
      onLoginSuccess(authorizedMenus, user);

    } catch (err) {
      if (err.response && err.response.status === 401) {
        setErrorMsg("Incorrect username or password.");
      } else {
        setErrorMsg("A server error occurred. Please try again later.");
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  
  // [추가] 가독성을 위해 스타일 객체 분리
  const styles = {
    container: {
      display: 'flex',
      height: '100vh',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    form: {
      background: '#ffffff',
      padding: '40px',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
      width: '360px',
      textAlign: 'center',
    },
    logo: {
      width: '200px',
      marginBottom: '10px',
    },
    header: {
      marginBottom: '25px',
      color: '#333',
      fontSize: '24px',
      fontWeight: '600',
    },
    inputGroup: {
      marginBottom: '20px',
      textAlign: 'left',
    },
    label: {
      display: 'block',
      marginBottom: '8px',
      color: '#555',
      fontSize: '14px',
      fontWeight: '500',
    },
    input: {
      width: '100%',
      padding: '12px 15px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      fontSize: '16px',
      boxSizing: 'border-box',
      transition: 'border-color 0.3s, box-shadow 0.3s',
    },
    // input:focus 가상 클래스는 인라인 스타일로 직접 구현하기 어려워 CSS를 사용하는 것이 좋지만,
    // 간단한 효과는 focus/blur 이벤트 핸들러로 구현할 수 있습니다. 여기서는 생략하고 CSS로 처리하는 것을 권장합니다.
    error: {
      color: '#e74c3c',
      marginBottom: '15px',
      fontSize: '14px',
    },
    button: {
      width: '100%',
      padding: '12px',
      background: 'linear-gradient(45deg, #007BFF, #0056b3)',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: '16px',
      fontWeight: 'bold',
      transition: 'background 0.3s, transform 0.1s',
    },
    buttonDisabled: {
      background: '#cccccc',
      cursor: 'not-allowed',
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit} style={styles.form}>
        {/* [추가] 로고 이미지 */}
        <img src={logo} alt="Company Logo" style={styles.logo} />

        {/* [수정] 영문 텍스트 및 스타일 적용 */}
        <h2 style={styles.header}>Login</h2>

        <div style={styles.inputGroup}>
          <label htmlFor="userid" style={styles.label}>Username</label>
          <input
            id="userid"
            type="text"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            required
            style={styles.input}
            placeholder="Enter your username"
          />
        </div>

        <div style={styles.inputGroup}>
          <label htmlFor="password" style={styles.label}>Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={styles.input}
            placeholder="Enter your password"
          />
        </div>

        {errorMsg && (
          <div style={styles.error}>{errorMsg}</div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={loading ? { ...styles.button, ...styles.buttonDisabled } : styles.button}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
}